module.exports = __webpack_public_path__ + "static/media/1006114.fbda5e23.png";